import { ICollectionProducts } from "../interfaces/shopify";
import { client } from "./shopifyClient";
export const getCollections = async (
  category: string,
  cursor?: string
): Promise<ICollectionProducts> => {
const query = `
{
  collectionByHandle(handle: "${category}") {
    id
    title
    banner: metafield(namespace: "custom", key: "banner") {
      type
      value
      references(first: 1) {
        edges {
          node {
            __typename
            ... on Metaobject {
              id
              type
              fields {
                key
                value
                reference {
                  __typename
                  ... on MediaImage {
                    image {
                      url
                      altText
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    products(first: 24, sortKey: TITLE, reverse: true, ${
      cursor ? `after: "${cursor}"` : ""
    }) {
      edges {
        cursor
        node {
          id
          handle
          title
          description
          tags
          images(first: 1) {
            edges {
              node {
                url
                altText
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
`;


  const response = await client.request(query);
  const collection = response.data.collectionByHandle;

  if (!collection) {
    return {
      categoryTitle: "",
      products: [],
      banner: null,
      pageInfo: { hasNextPage: false, endCursor: null },
    };
  }

  const products = collection.products.edges?.map((edge: any) => edge.node) ?? [];
  const parentProducts = products.filter((p: any) =>
    p.tags?.includes("shsdparentproduct")
  );

  return {
    categoryTitle: collection.title,
    products: parentProducts,
    banner: collection.banner ?? null,
    pageInfo: collection.products.pageInfo,
  };
};
